import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

const SITE_URL = import.meta?.env?.VITE_SITE_URL || 'https://hoosierlifeinsurance.com';

const ALL_ARTICLES = [
  {
    title: 'Term vs. Whole Life Insurance: What Indianapolis Homeowners Need to Know',
    description: "Compare term and whole life insurance for Indianapolis homeowners. Real cost comparisons, examples, and expert recommendations.",
    slug: '/resources/term-vs-whole-life-indianapolis-homeowners',
    category: 'Life Insurance Basics',
    readTime: '10 min read',
    featured: true,
    image: 'https://public.readdy.ai/ai/img_res/ed91c67d2aab6e2b5d82d3e48929f0dd.jpg',
  },
  {
    title: 'How Much Life Insurance Do Indiana Families Really Need?',
    description: "Calculate the right coverage amount for your Indiana family using the DIME method — income, debts, education, and future goals.",
    slug: '/resources/how-much-life-insurance-indiana-families-need',
    category: 'Coverage Planning',
    readTime: '7 min read',
    featured: false,
    image: 'https://readdy.ai/api/search-image?query=Indiana%20family%20of%20four%20sitting%20together%20at%20kitchen%20table%20reviewing%20financial%20documents%20and%20calculator%20warm%20natural%20lighting%20showing%20thoughtful%20planning%20and%20family%20financial%20security%20discussion%20lifestyle%20photography%20style&width=800&height=600&seq=res2&orientation=landscape',
  },
  {
    title: "Mortgage Protection Insurance: A Fishers Family's Story",
    description: 'Real story of how mortgage protection insurance helped a Fishers family keep their home after an unexpected loss.',
    slug: '/resources/mortgage-protection-fishers-family-story',
    category: 'Real Stories',
    readTime: '6 min read',
    featured: false,
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20two-story%20suburban%20home%20in%20Fishers%20Indiana%20with%20manicured%20front%20yard%20and%20welcoming%20entrance%20during%20sunset%20representing%20family%20home%20protection%20and%20mortgage%20security%20warm%20inviting%20real%20estate%20photography%20style&width=800&height=600&seq=res3&orientation=landscape',
  },
  {
    title: 'Final Expense Insurance: What Indiana Seniors Should Know',
    description: 'Guide to final expense insurance for Indiana seniors. Coverage options, costs, and how to protect your family from burial expenses.',
    slug: '/resources/final-expense-insurance-indiana-seniors',
    category: 'Senior Planning',
    readTime: '9 min read',
    featured: false,
    image: 'https://readdy.ai/api/search-image?query=Dignified%20senior%20couple%20in%20their%2060s%20sitting%20on%20porch%20of%20Indiana%20home%20holding%20hands%20and%20smiling%20peacefully%20representing%20retirement%20planning%20and%20final%20expense%20preparation%20warm%20natural%20light%20lifestyle%20photography%20style&width=800&height=600&seq=res4&orientation=landscape',
  },
  {
    title: 'Annuities and Retirement Planning for Indiana Residents',
    description: 'How annuities can provide guaranteed retirement income for Indiana residents. Types, benefits, and when to consider an annuity.',
    slug: '/resources/annuities-retirement-planning-indiana',
    category: 'Retirement',
    readTime: '9 min read',
    featured: false,
    image: 'https://readdy.ai/api/search-image?query=Peaceful%20retirement%20scene%20with%20senior%20couple%20enjoying%20coffee%20on%20lakeside%20deck%20in%20Indiana%20during%20morning%20golden%20hour%20representing%20financial%20security%20and%20retirement%20income%20planning%20serene%20lifestyle%20photography%20style&width=800&height=600&seq=res5&orientation=landscape',
  },
  {
    title: '5 Life Insurance Mistakes Indiana Families Make (And How to Avoid Them)',
    description: "Common life insurance mistakes made by Indiana families and how to avoid them. Learn from others' errors and protect your family properly.",
    slug: '/resources/life-insurance-mistakes-indiana-families',
    category: 'Common Mistakes',
    readTime: '8 min read',
    featured: false,
    image: 'https://readdy.ai/api/search-image?query=Young%20Indiana%20family%20with%20children%20sitting%20together%20reviewing%20insurance%20documents%20with%20concerned%20but%20hopeful%20expressions%20representing%20learning%20from%20mistakes%20and%20making%20better%20insurance%20decisions%20documentary%20style%20photography&width=800&height=600&seq=res6&orientation=landscape',
  },
  {
    title: 'Life Insurance for Smokers in Indiana: Rates & Best Companies',
    description: "Smokers pay 2-3x more — but the right strategy can cut your premiums significantly. Which Indiana carriers are most lenient for tobacco users.",
    slug: '/resources/life-insurance-for-smokers-indiana',
    category: 'High-Risk Coverage',
    readTime: '9 min read',
    featured: false,
    image: 'https://readdy.ai/api/search-image?query=Thoughtful%20Indiana%20adult%20reviewing%20life%20insurance%20documents%20at%20home%20desk%20with%20warm%20lamp%20light%20representing%20smoker%20seeking%20affordable%20life%20insurance%20coverage%20financial%20planning%20responsible%20adult%20lifestyle%20photography&width=800&height=600&seq=res7&orientation=landscape',
  },
  {
    title: 'Life Insurance for Business Owners in Indiana',
    description: "Key person insurance, buy-sell agreements, and executive benefits — the complete guide for Indiana entrepreneurs and business owners.",
    slug: '/resources/life-insurance-for-business-owners-indiana',
    category: 'Business Planning',
    readTime: '11 min read',
    featured: false,
    image: 'https://readdy.ai/api/search-image?query=Professional%20Indiana%20business%20owner%20in%20modern%20office%20reviewing%20financial%20documents%20and%20business%20insurance%20plans%20confident%20entrepreneur%20in%20well-lit%20contemporary%20workspace%20Indianapolis%20business%20district%20background%20lifestyle%20photography&width=800&height=600&seq=res8&orientation=landscape',
  },
  {
    title: 'No Medical Exam Life Insurance in Indiana: Complete Guide',
    description: "Get covered in 24-72 hours without a doctor visit. How no-exam life insurance works, who qualifies, and the best Indiana carriers.",
    slug: '/resources/no-medical-exam-life-insurance-indiana-guide',
    category: 'No-Exam Coverage',
    readTime: '8 min read',
    featured: false,
    image: 'https://readdy.ai/api/search-image?query=Indiana%20resident%20completing%20online%20life%20insurance%20application%20on%20laptop%20at%20home%20kitchen%20table%20representing%20fast%20easy%20no%20medical%20exam%20life%20insurance%20approval%20process%20modern%20digital%20lifestyle%20photography%20warm%20natural%20light&width=800&height=600&seq=res9&orientation=landscape',
  },
  {
    title: 'Life Insurance for Seniors in Indiana: Best Options Over 60, 70 & 80',
    description: "The best life insurance options for Indiana seniors at every age — with real rates, carrier comparisons, and honest advice.",
    slug: '/resources/life-insurance-for-seniors-indiana',
    category: 'Senior Planning',
    readTime: '10 min read',
    featured: false,
    image: 'https://readdy.ai/api/search-image?query=Active%20Indiana%20senior%20couple%20in%20their%2070s%20walking%20together%20in%20a%20beautiful%20park%20during%20autumn%20representing%20healthy%20retirement%20lifestyle%20and%20senior%20life%20insurance%20planning%20warm%20golden%20light%20lifestyle%20photography&width=800&height=600&seq=res10&orientation=landscape',
  },
  {
    title: 'Life Insurance Riders in Indiana: Which Add-Ons Are Worth It?',
    description: "An honest breakdown of every major life insurance rider — which ones provide real value and which are overpriced extras you can skip.",
    slug: '/resources/life-insurance-riders-indiana',
    category: 'Policy Customization',
    readTime: '10 min read',
    featured: false,
    image: 'https://readdy.ai/api/search-image?query=Indiana%20insurance%20professional%20reviewing%20policy%20documents%20with%20client%20at%20modern%20office%20desk%20showing%20life%20insurance%20rider%20options%20and%20customization%20warm%20professional%20consultation%20lifestyle%20photography&width=800&height=600&seq=res11&orientation=landscape',
  },
  {
    title: 'How to Choose a Life Insurance Company in Indiana',
    description: "Financial strength ratings, underwriting, claims history — the 6 criteria and 7 questions every Indiana family should use before buying.",
    slug: '/resources/how-to-choose-life-insurance-company-indiana',
    category: 'Carrier Selection',
    readTime: '10 min read',
    featured: false,
    image: 'https://readdy.ai/api/search-image?query=Indiana%20family%20comparing%20life%20insurance%20company%20options%20on%20laptop%20and%20printed%20documents%20at%20home%20representing%20careful%20carrier%20selection%20process%20and%20financial%20decision%20making%20warm%20home%20office%20lifestyle%20photography&width=800&height=600&seq=res12&orientation=landscape',
  },
  {
    title: 'Indiana Life Insurance Needs Calculator — Free Interactive Tool',
    description: "Answer 5 questions and get your exact coverage gap, policy recommendation, and estimated monthly premium. Indiana-specific rates, 100% private.",
    slug: '/resources/indiana-life-insurance-calculator',
    category: 'Tools & Calculators',
    readTime: '2 min tool',
    featured: false,
    image: 'https://readdy.ai/api/search-image?query=Indiana%20family%20using%20interactive%20life%20insurance%20calculator%20on%20laptop%20at%20bright%20modern%20home%20office%20desk%20with%20financial%20documents%20and%20coffee%20representing%20digital%20financial%20planning%20tool%20clean%20minimal%20lifestyle%20photography&width=800&height=600&seq=res13&orientation=landscape',
  },
  {
    title: 'Life Insurance Glossary — 55+ Terms Defined in Plain English',
    description: "Every life insurance term you need to know, explained without jargon. From accelerated death benefit to whole life insurance — with Indiana-specific context on every definition.",
    slug: '/resources/life-insurance-glossary-indiana',
    category: 'Reference',
    readTime: 'Reference guide',
    featured: false,
    image: 'https://readdy.ai/api/search-image?query=Open%20dictionary%20or%20reference%20book%20on%20clean%20white%20desk%20with%20reading%20glasses%20and%20coffee%20representing%20life%20insurance%20glossary%20and%20terminology%20reference%20guide%20for%20Indiana%20residents%20minimal%20clean%20lifestyle%20photography&width=800&height=600&seq=res14&orientation=landscape',
  },
  {
    title: 'Indiana Life Insurance Buying Checklist — 35 Steps to Full Coverage',
    description: "A free printable step-by-step checklist for buying life insurance in Indiana. 35 steps across 6 phases — from calculating your needs to managing your policy. Great for first-time buyers.",
    slug: '/resources/life-insurance-checklist-indiana',
    category: 'Checklists',
    readTime: 'Interactive checklist',
    featured: false,
    image: 'https://readdy.ai/api/search-image?query=Indiana%20family%20reviewing%20life%20insurance%20checklist%20documents%20at%20kitchen%20table%20with%20pen%20and%20coffee%20representing%20organized%20step%20by%20step%20buying%20process%20warm%20natural%20light%20clean%20home%20lifestyle%20photography&width=800&height=600&seq=res15&orientation=landscape',
  },
];

const CATEGORIES = ['All', 'Life Insurance Basics', 'Coverage Planning', 'Senior Planning', 'Retirement', 'Real Stories', 'Common Mistakes', 'High-Risk Coverage', 'Business Planning', 'No-Exam Coverage', 'Policy Customization', 'Carrier Selection', 'Tools & Calculators', 'Reference', 'Checklists'];

export default function ResourcesPage() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    document.title = 'Life Insurance Resources & Guides for Indiana Families';
    const updateMeta = (selector: string, attr: string, value: string) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };
    updateMeta('meta[name="description"]', 'content', 'Expert life insurance guides for Indiana families. Learn about term vs whole life, mortgage protection, final expense, annuities, riders, and how to choose the right carrier.');
    updateMeta('meta[name="keywords"]', 'content', 'life insurance guides Indiana, Indiana insurance resources, term vs whole life, mortgage protection, final expense, retirement planning Indiana');
    updateMeta('meta[property="og:url"]', 'content', `${SITE_URL}/resources`);

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.appendChild(canonical); }
    canonical.href = `${SITE_URL}/resources`;

    const breadcrumbSchema = {
      '@context': 'https://schema.org', '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE_URL}/` },
        { '@type': 'ListItem', position: 2, name: 'Resources', item: `${SITE_URL}/resources` },
      ],
    };
    const injectSchema = (id: string, data: object) => {
      let script = document.getElementById(id) as HTMLScriptElement | null;
      if (!script) { script = document.createElement('script'); script.id = id; script.type = 'application/ld+json'; document.head.appendChild(script); }
      script.textContent = JSON.stringify(data);
    };
    injectSchema('schema-resources-breadcrumb', breadcrumbSchema);
    return () => { document.getElementById('schema-resources-breadcrumb')?.remove(); };
  }, []);

  const filtered = ALL_ARTICLES.filter(a => {
    const matchCat = activeCategory === 'All' || a.category === activeCategory;
    const matchSearch = searchQuery === '' || a.title.toLowerCase().includes(searchQuery.toLowerCase()) || a.description.toLowerCase().includes(searchQuery.toLowerCase());
    return matchCat && matchSearch;
  });

  const featured = ALL_ARTICLES.find(a => a.featured);
  const showFeatured = activeCategory === 'All' && searchQuery === '';

  return (
    <div className="min-h-screen bg-white">
      <title>Life Insurance Resources & Guides for Indiana Families | Hoosier Life Insurance</title>
      <Header />

      {/* Hero */}
      <section className="relative bg-gradient-to-br from-[#FDF6F0] via-white to-[#F9F7F4] pt-32 pb-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center max-w-3xl mx-auto mb-10">
            <h1 className="text-5xl font-bold text-gray-900 mb-5">Life Insurance Resources for Indiana Families</h1>
            <p className="text-xl text-gray-600 leading-relaxed">Expert guides, real stories, and practical advice to help you make informed decisions about protecting your family's financial future.</p>
          </div>

          {/* Stats Bar */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto mb-10">
            {[
              { num: '12', label: 'In-Depth Guides' },
              { num: '50+', label: 'Topics Covered' },
              { num: '100%', label: 'Indiana-Focused' },
              { num: 'Free', label: 'Always Free' },
            ].map(s => (
              <div key={s.label} className="bg-white rounded-xl border border-gray-200 p-4 text-center">
                <p className="text-2xl font-bold text-[#D97642]">{s.num}</p>
                <p className="text-sm text-gray-600">{s.label}</p>
              </div>
            ))}
          </div>

          {/* Search */}
          <div className="max-w-xl mx-auto">
            <div className="relative">
              <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-lg" />
              <input
                type="text"
                placeholder="Search guides (e.g. smokers, seniors, riders...)"
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                className="w-full pl-11 pr-4 py-3 border-2 border-gray-200 rounded-xl text-sm focus:outline-none focus:border-[#D97642] transition-colors"
              />
              {searchQuery && (
                <button onClick={() => setSearchQuery('')} className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer">
                  <i className="ri-close-line text-lg" />
                </button>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="sticky top-0 z-10 bg-white border-b border-gray-200 py-3">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide">
            {CATEGORIES.map(cat => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`whitespace-nowrap px-4 py-2 rounded-full text-sm font-semibold transition-all cursor-pointer ${activeCategory === cat ? 'bg-[#D97642] text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Article */}
      {showFeatured && featured && (
        <section className="py-12 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <p className="text-xs font-bold uppercase tracking-widest text-[#D97642] mb-4">Featured Guide</p>
            <Link to={featured.slug} className="group grid md:grid-cols-2 gap-0 bg-white rounded-2xl border-2 border-[#D97642] overflow-hidden hover:shadow-xl transition-all duration-300">
              <div className="relative h-64 md:h-auto overflow-hidden">
                <img src={featured.image} alt={featured.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" width={800} height={600} loading="eager" />
                <div className="absolute inset-0 bg-gradient-to-r from-transparent to-black/10" />
              </div>
              <div className="p-8 flex flex-col justify-center">
                <span className="inline-block px-3 py-1 bg-[#D97642] text-white text-xs font-bold rounded-full mb-4 w-fit">{featured.category}</span>
                <h2 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-[#D97642] transition-colors">{featured.title}</h2>
                <p className="text-gray-600 leading-relaxed mb-6">{featured.description}</p>
                <div className="flex items-center gap-4 text-sm text-gray-500 mb-6">
                  <span><i className="ri-time-line mr-1" />{featured.readTime}</span>
                  <span><i className="ri-map-pin-line mr-1" />Indianapolis, IN</span>
                </div>
                <div className="flex items-center gap-2 text-[#D97642] font-semibold group-hover:gap-3 transition-all">
                  <span>Read Full Guide</span>
                  <i className="ri-arrow-right-line" />
                </div>
              </div>
            </Link>
          </div>
        </section>
      )}

      {/* Articles Grid */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          {filtered.length === 0 ? (
            <div className="text-center py-20">
              <i className="ri-search-line text-5xl text-gray-300 mb-4 block" />
              <p className="text-xl text-gray-500">No guides found for "{searchQuery}"</p>
              <button onClick={() => { setSearchQuery(''); setActiveCategory('All'); }} className="mt-4 text-[#D97642] font-semibold hover:underline cursor-pointer">Clear filters</button>
            </div>
          ) : (
            <>
              <div className="flex items-center justify-between mb-6">
                <p className="text-sm text-gray-500">{filtered.length} guide{filtered.length !== 1 ? 's' : ''} {activeCategory !== 'All' ? `in ${activeCategory}` : ''}</p>
              </div>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {filtered.filter(a => !a.featured || !showFeatured).map(article => (
                  <Link key={article.slug} to={article.slug} className="group bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                    <div className="relative h-52 overflow-hidden">
                      <img src={article.image} alt={article.title} title={article.title} loading="lazy" decoding="async" width={800} height={600} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                      <div className="absolute top-4 left-4">
                        <span className="inline-block px-3 py-1 bg-[#D97642] text-white text-xs font-bold rounded-full">{article.category}</span>
                      </div>
                    </div>
                    <div className="p-6">
                      <div className="flex items-center gap-2 text-xs text-gray-500 mb-3">
                        <i className="ri-time-line" /><span>{article.readTime}</span>
                      </div>
                      <h2 className="text-lg font-bold text-gray-900 mb-3 group-hover:text-[#D97642] transition-colors leading-snug">{article.title}</h2>
                      <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-2">{article.description}</p>
                      <div className="flex items-center gap-2 text-[#D97642] font-semibold text-sm group-hover:gap-3 transition-all">
                        <span>Read Guide</span><i className="ri-arrow-right-line" />
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gradient-to-br from-[#1A3A52] to-[#0F2A3F]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">Have Questions About Life Insurance?</h2>
          <p className="text-xl text-white/80 mb-8 leading-relaxed">Benjamin Wright is here to help Indiana families understand their options and find the right coverage.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/book-appointment" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-[#1A3A52] font-semibold rounded-lg hover:bg-gray-50 transition-all whitespace-nowrap">
              <i className="ri-calendar-line text-xl" /><span>Schedule a Call</span>
            </Link>
            <Link to="/instant-quote" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#0F2A3F] text-white font-semibold rounded-lg hover:bg-[#0A1F2E] transition-all whitespace-nowrap border border-white/20">
              <i className="ri-calculator-line text-xl" /><span>Get Instant Quote</span>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
